import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { URL_SERVICIOS } from 'src/app/config/config';
import { GeneralService } from 'src/app/services/general.service';
import { ZoomService } from 'src/app/services/zoom.service';
import { URL_DOCS } from 'src/app/config/config';
import { EncriptacionService } from 'src/app/services/encriptacion.service';

@Component({
  selector: 'app-lobby-acomp',
  templateUrl: './lobby-acomp.component.html',
  styleUrls: ['./lobby-acomp.component.css']
})
export class LobbyAcompComponent implements OnInit {

  public id_room: any;
  public parametros_url: any;
  public entro_anfitrion: boolean = false;
  consulta: any = {};

  _usuario: any = {};

  limit_tips

  fade: boolean = false;

  tips: any[] = [];
  currentTipIndex: number = 0;
  tipsInterval: any;

  campaigns: any = {};
  URL_DOCUMENTS = URL_DOCS;



  pageInfo: any = {};
  constructor(
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private _zoomServices: ZoomService,
    private generalService: GeneralService) {
    this.activatedRoute.params.subscribe(parametros => {

      this.parametros_url = parametros;
      //console.log(this.parametros_url);

    });
    this.id_room = this.parametros_url.idReunion;
    let params = {
      id_consulta: this.parametros_url.id_consulta
    };
    this._zoomServices.postUpdateStartLobby(params)
      .then(result => {
        //console.log(result);
      })
      .catch(error => {
        console.log(error);
      });
    this.getConsulta(this.parametros_url.id_consulta);

  }

  ngOnInit(): void {
    this.observador();

    this.getInfoTips();
    this.getInfoCampaigns();
        this.pageInfo = new EncriptacionService().getPageInfo();
    
  }

  getConsulta(id_consulta) {
    this._zoomServices.getConsulta(id_consulta)
      .then(result => {
        // console.log(result);
        this.consulta = result;
      })
      .catch(error => {
        console.log(error);
      });
  }

  async observador() {

    const httpOptions = {
      headers: new HttpHeaders({
        'authorization': sessionStorage.getItem('token'),
        'Content-Type': 'application/json'
      })
    };


    while (!this.entro_anfitrion) {

      this.http.post(URL_SERVICIOS + '/postMeetingState', ({ id_room: this.id_room }), httpOptions).subscribe((
        data: any[]) => {
        //console.log(data);
        if (data[0].zoo_mee_active) {
          //console.log("Ya entraron");

        if (this.isModalOpen == false) {
          this.entro_anfitrion = true;
          var url = "videoconsulta-group/" + this.parametros_url.idReunion + "/" + this.parametros_url.id_consulta + "/" + this.parametros_url.med_con_id;

          this.router.navigate([url]);
        }
        }
      });
      //console.log("No entrarron");
      await this.sleep(10000);
    }

  }
  sleep(ms = 0) {
    return new Promise(r => setTimeout(r, ms));
  }


  ngOnDestroy() {

    this.entro_anfitrion = true;
    if (this.tipsInterval) {
      clearInterval(this.tipsInterval);
    }
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event) {
    this.entro_anfitrion = true;
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    this.entro_anfitrion = true;
  }
  startTipsRotation() {
    this.tipsInterval = setInterval(() => {
      this.fade = true; // inicia fade out

      setTimeout(() => {
        this.currentTipIndex = (this.currentTipIndex + 1) % this.tips.length;
        this.fade = false; // fade in
      }, 800); // tiempo que coincide con el CSS
    }, 10000);
  }

  getInfoTips() {
    this.generalService.getInfoTips().then((result: any) => {
      const tipsFiltrados = result.data?.filter((t: any) => t.con_info_type === 1) || [];

      this.tips = tipsFiltrados;
      // console.log(this.tips);


      if (this.tips.length > 0) {
        this.startTipsRotation();
      }
    });
  }


  getInfoCampaigns() {
    this.generalService.getInfoCampaigns().then(result => {
      this.campaigns = result;
      //  console.log(this.campaigns);

    })
  }


  isModalOpen = false;
  openModal(): void {
    this.isModalOpen = true;
    // console.log(this.isModalOpen);

  }

  closeModal(): void {
    this.isModalOpen = false;
    // console.log(this.isModalOpen);

  }
}
